export enum StepPage {
  BILLING = "Facturación",
  PAY = "Pago",
  PAYMENT_SUMMARY = "Resumen de pago",
}
